import { FieldValues, UseFormGetValues, UseFormReset } from "react-hook-form";

export const useResetForm = <TFieldValues extends FieldValues>() => {
  const resetToEmpty = (
    getValues: UseFormGetValues<TFieldValues>,
    reset: UseFormReset<TFieldValues>
  ) => {
    const values = getValues();

    const clearValues = (obj) =>
      Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          if (Array.isArray(value)) return [key, []];
          if (value !== null && typeof value === "object")
            return [key, clearValues(value)];
          if (typeof value === "number") return [key, null];
          return [key, ""];
        })
      );

    reset(clearValues(values));
  };

  return {
    resetToEmpty
  }
};
